import { parseOnlyNumericValue, safeToString, sliceText } from "../../../../utils/common";

export const EMP_SETUP_CONST =

{
  employmentType: {
    fullWidth: true,
    label: "Employment Type",
    options: [
      { id: "full_time", name: "Permanent" },
      { id: "probationary", name: "Provision Period" },
      { id: "part_time", name: "Part Time" },
      { id: "contractual", name: "Contractual" },
    ],
    multiSelect: true,
    searchable: false,
    clearable: true,
    placeholder: "Select Here...",
    name: "employmentType"
  },
  isProvisionPeriod: {
    name: "isProvisionPeriod",
    fullWidth: true,
    label: "Provision Period",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here..."

  },
  provisionDays: {
    name: "provisionDays",
    type: "number",
    fullWidth: true,
    label: "Provision Days",
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      }

    }
  },
  isNoticePeriod: {
    name: "isNoticePeriod",
    fullWidth: true,
    label: "Notice Period",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here..."
  },
  noticeDays: {
    name: "noticeDays",
    type: "number",
    fullWidth: true,
    label: "Notice days",
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      }

    }
  },
  prefix: {
    name: "prefix",
    type: "text",
    fullWidth: true,
    required: true,
    label: "Emp Code Prefix",
    placeholder: "Type Here...",
 
  },
  
  leave_type: {
    fullWidth: true,
    required:true,
    name:"leave_type",
    label: "Leave Period",
    options: [
      { id: "calender_year", name: "Calender Year" },
      { id: "financial_year", name: "Financial Year" },
    ],
    placeholder: "Select Here...",
  },
  leave_staging: {
    fullWidth: true,
    required:true,
    name:"leave_staging",
    label: "Weekly Off",
    placeholder:"Select Here...",
    options: [
      { id: true, name: "Organization Label" },
      { id: false, name: "Employee Label" },
    ],
  },
  workMode: {
    fullWidth: true,
    multiSelect: true,
    searchable: true,
    clearable: true,
    label: "Work Location",
    options: [
      { id: "Work-From-Home", name: "Work From Home" },
      { id: "Remote", name: "Remote" },
      { id: "On-Site", name: "On-Site" },
    ],
    placeholder: "Select Here...",
  },
  shiftManagement: {
    name: "shiftManagement",
    fullWidth: true,
    label: "Shift Management",
    options: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    placeholder: "Select Here..."
  },
  loginTime: {
    name: "loginTime",
    type: "time",
    fullWidth: true,
    label: "Login Time",
    placeholder: "Type Here...",
    valueSinc:true,
    
  },
  logoutTime: {
    name: "logoutTime",
    type: "time",
    fullWidth: true,
    label: "Logout Time",
    placeholder: "Type Here...",
    valueSinc:true,

  },
  breakTime: {
    name: "breakTime",
    type: "number",
    fullWidth: true,
    label: "Break Time",
    placeholder: "Type Here...",
    prefix:"min",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(parseOnlyNumericValue(safeToString(value)), 2);
      }

    }

  }
}